import LatLng from './LatLng'

interface ThingConfig {
  id: string
  uriId: string
  name: string
  aliasesQuantity: boolean
  isAlias: boolean
  type: string
  subType: string
  tags: []
  contact_on?: boolean
  domain: string
  // status: string
  // path?: LatLng[]
  lastReport?: number
  // heading?: string
  // position: LatLng
  // speed: number
  // speedLastModified: number
  agents: string[]
  serviceName: string
  serviceStatus: string
  created: string
  serviceList: string[]
  mileage_reading: number,
  usage_reading: number,
  additionalInfo: any
  photo?: string
}

interface VehicleConfig extends ThingConfig {
  make: string
  model: string
  year: number
  color: string
  chasisNumber: string
  engineNumber: string
}

interface FlexConfig extends ThingConfig {
  batteryLevel?: number
}
interface ThingMap {
  [id: string]: Thing
}
//Se quita la propiedad "readonly" de "class Thing" para poder modificar sus valores dinamicamente mediante WAMP//

class Thing {
  public id: string
  public uriId: string
  public name: string
  public aliasesQuantity: boolean
  public isAlias: boolean
  public type: string
  public subType: string
  public tags: []
  public domain: string
  // public status: string
  // public path?: LatLng[]
  public lastReport?: number
  // public heading?: string
  // public position?: LatLng
  // public speed: number
  // public speedLastModified: number
  public agents: string[]
  public serviceName: string
  public serviceStatus: string
  public created: string
  public serviceList: string[]
  public mileage_reading: number
  public usage_reading: number
  public additionalInfo: any
  public photo?: string

  constructor(configuration: ThingConfig) {
    this.id = configuration.id
    this.uriId = configuration.uriId
    this.name = configuration.name
    this.aliasesQuantity = configuration.aliasesQuantity
    this.isAlias = configuration.isAlias
    this.type = configuration.type
    this.subType = configuration.subType
    this.tags = configuration.tags
    this.domain = configuration.domain
    // this.status = configuration.status
    // this.path = configuration.path
    this.lastReport = configuration.lastReport
    // this.heading = configuration.heading
    // this.position = configuration.position
    // this.speed = configuration.speed
    // this.speedLastModified = configuration.speedLastModified
    this.agents = configuration.agents
    this.serviceName = configuration.serviceName
    this.serviceStatus = configuration.serviceStatus
    this.created = configuration.created
    this.serviceList = configuration.serviceList
    this.mileage_reading = configuration.mileage_reading
    this.usage_reading = configuration.usage_reading
    this.additionalInfo = configuration.additionalInfo
    this.photo = configuration.photo
  }
}

class Vehicle extends Thing {
  public contact_on?: boolean
  public make: string
  public model: string
  public year: number
  public color: string
  public chasisNumber: string
  public engineNumber: string

  constructor(configuration: VehicleConfig) {
    super(configuration)
    this.contact_on = configuration.contact_on
    this.make = configuration.make
    this.model = configuration.model
    this.year = configuration.year
    this.color = configuration.color
    this.chasisNumber = configuration.chasisNumber
    this.engineNumber = configuration.engineNumber

  }
}

class Flex extends Thing {
  public batteryLevel?: number

  constructor(configuration: FlexConfig) {
    super(configuration)
    this.batteryLevel = configuration.batteryLevel
  }
}

export { Thing, Vehicle, Flex, ThingMap }
